import { ScrollArea, Skeleton } from '@ibsys/kit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useKmEntityType } from '@/entities/ontology';
import { EntityTypeAttrsSection } from './EntityTypeAttrsSection';
import { EntityTypeRelationsSection } from './EntityTypeRelationsSection';
import { OntologyForm } from './OntologyForm';

type Props = {
  code?: string;
  onUnsavedChange?: (hasUnsaved: boolean) => void;
};

/**
 * Правая панель: форма основной информации и (для загруженного типа) секции
 * атрибутов схемы и типов связей.
 */
export const OntologyFormSection: FC<Props> = ({ code, onUnsavedChange }) => {
  const { t } = useTranslation('ontology');
  const isCreate = code === 'create';
  const detailCode = isCreate ? undefined : code;

  const { data: entity, isLoading } = useKmEntityType(detailCode);

  if (isLoading) {
    return <Skeleton className="h-full" />;
  }

  if (isCreate) {
    return (
      <ScrollArea className="h-full">
        <div className="flex flex-col gap-4">
          <OntologyForm key="create" onUnsavedChange={onUnsavedChange} />
        </div>
      </ScrollArea>
    );
  }

  if (entity) {
    return (
      <ScrollArea className="h-full">
        <div className="flex flex-col gap-4">
          <OntologyForm key={entity.code} initial={entity} onUnsavedChange={onUnsavedChange} />
          <EntityTypeAttrsSection code={entity.code} />
          <EntityTypeRelationsSection code={entity.code} />
        </div>
      </ScrollArea>
    );
  }

  return <div className="flex items-center justify-center h-full text-muted-foreground">{t('selectType')}</div>;
};
